
  const translations = {
    es: {
      title: "Iniciar Sesión",
      email: "Correo electrónico",
      password: "Contraseña",
      forgotPassword: "¿Olvidaste tu contraseña?",
      loginButton: "Iniciar Sesión",
      or: "o",
      googleError: "Error en el inicio con Google",
      loginSuccess: "Inicio de sesión exitoso",
      googleLoginSuccess: "Inicio de sesión con Google exitoso",
      networkError: "No se pudo conectar con el servidor",
      changeLanguage: "Cambiar idioma",
      showPassword: "Mostrar contraseña",
      hidePassword: "Ocultar contraseña",
      errors: {
        userNotRegistered: "Usuario no registrado",
        emailNotVerified: "Correo electrónico no verificado",
        inactiveAccount: "Cuenta inactiva",
        invalidGoogleToken: "Token de Google inválido",
        default: "Error en el inicio de sesión",
      },
    },
    en: {
      title: "Login",
      email: "Email",
      password: "Password",
      forgotPassword: "Forgot your password?",
      loginButton: "Login",
      or: "or",
      googleError: "Google login error",
      loginSuccess: "Login successful",
      googleLoginSuccess: "Google login successful",
      networkError: "Could not connect to server",
      changeLanguage: "Change the language",
      showPassword: "Show password",
      hidePassword: "Hide password",
      errors: {
        userNotRegistered: "User not registered",
        emailNotVerified: "Email not verified",
        inactiveAccount: "Inactive account",
        invalidGoogleToken: "Invalid Google token",
        default: "Login error",
      },
    },
  };


  export default translations